<template>
  <transition name="slide-up">
    <div v-show="showNavbar" class="navbar-bottom-mobile container mobile">
      <div class="d-flex justify-content-around align-items-center">
        <div class="text-center">
          <img @click="getHomePage" :src="bg.icon_menu_home" alt="" />
          <p class="m-0 text-center menu-name">{{ $t("wap.text26") }}</p>
        </div>
        <div class="text-center">
          <img @click="getOrder" :src="bg.icon_menu_order" alt="" />
          <p class="m-0 text-center menu-name">{{ $t("order") }}</p>
        </div>
        <div class="text-center" v-if="!info">
          <img @click="handleShowProfile" :src="bg.icon_menu_user" alt="" />
          <p class="m-0 menu-name">{{ $t("login") }}</p>
        </div>
        <div v-if="info" class="text-center">
          <img
            @click="routerPush('/bang-gia')"
            :src="bg.icon_menu_price_table"
            alt=""
          />
          <p class="m-0 menu-name">{{ $t("wap.text175") }}</p>
        </div>
        <div class="text-center">
          <img @click="handleShowMenu" :src="bg.icon_menu_more" alt="" />
          <p class="m-0 menu-name">{{ $t("viewMore") }}</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { getBackGround } from "../../utils/wapAuth";
import { getToken, getInfo } from "@/utils/auth.js";
import { SOURCE_BANK } from "../../constant/contant";
import { isEmpty } from "../../utils/validate";

export default {
  name: "mobile-navbar-bottom",
  components: {},
  props: {},
  data() {
    return {
      lastScrollY: 0,
      showNavbar: true,
      info: getInfo(),
      bg: getBackGround()
    };
  },
  created() {},
  computed: {},
  watch: {
    "$store.getters.isReRenderComponent": function(newValue) {
      if (newValue > 1 && !isEmpty(getToken().vga)) {
        this.info = getInfo();
        console.log("info____________", this.info);
      }
    }
  },
  methods: {
    getToken,
    getInfo,
    handleScroll() {
      const currentScroll = window.scrollY;
      const diff = Math.abs(currentScroll - this.lastScrollY);

      if (diff >= 100) {
        if (currentScroll > this.lastScrollY) {
          // Cuộn xuống trên 20px
          this.showNavbar = false;
        } else {
          // Cuộn lên trên 20px
          this.showNavbar = true;
        }
        this.lastScrollY = currentScroll;
      }
    },
    getIconBySource(type) {
      let icon = "";
      const isSource = getToken().bank_id == SOURCE_BANK.BIDV;
      switch (type) {
        case "order":
          icon = isSource
            ? require("@/assets/img/iconV2/btn_order_bidv.svg")
            : require("@/assets/img/iconV2/btn_order.svg");
          break;
        case "search":
          icon = isSource
            ? require("@/assets/img/iconV2/btn_search_bidv.svg")
            : require("@/assets/img/iconV2/btn_search.svg");
          break;
        case "menu":
          icon = isSource
            ? require("@/assets/img/iconV2/btn_menu_bidv.svg")
            : require("@/assets/img/iconV2/btn_menu.svg");
          break;
        default:
          break;
      }
      return icon;
    },
    handleShowProfile() {
      if (!getInfo()) {
        this.$store.dispatch("showLoginDialog");
        return;
      }
      this.$store.dispatch("setShowProfile", true);
    },

    handleShowMenu() {
      this.$store.dispatch("setShowMenuApp", true);
    },
    getOrder() {
      if (!getInfo()) {
        this.$store.dispatch("showLoginDialog");
        return;
      }
      this.$router.push("/wap/history");
    },
    routerPush(path) {
      return this.$router.push(path);
    },
    getHomePage() {
      this.$router.push("/");
    },
    handleShowDialogSearchFacility() {
      this.$store.dispatch("show_dialog_search_facility", true);
    }
  },
  mounted() {
    this.lastScrollY = window.scrollY;
    setTimeout(() => {
      window.addEventListener("scroll", this.handleScroll);
    }, 500);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped>
.menu-name {
  font-weight: 600;
  font-size: 8.82px;
  line-height: 11.75px;
  letter-spacing: 0%;
  text-align: center;
  padding-top: 4px;
}
.navbar-bottom-mobile {
  box-shadow: 0px -0.73px var(--24) -2.94px #0000000f;

  box-shadow: 0px -1.47px 5.88px 0px #0000000a;
  transition: transform 0.3s ease;
  position: fixed;
  z-index: 900;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 0;
  max-height: 70px;
  min-height: 70px;
  background-color: #ffff;
}
.mobile {
  display: none;
}
.pc {
  display: block;
}

@media (max-width: 991px) {
}
@media screen and (min-width: 0px) and (max-width: 992px) {
  .lang-pc {
    display: none;
  }
  .mobile {
    display: block;
  }
  .pc {
    display: none;
  }
}
</style>
